export class FavouritesApiRoutes {
    public static GET_USERS_FAVOURITES = '/user';
}